import { LineItemRequest } from '../client-checkout';

class SelectedVariant {
  constructor(windowData, parentPage) {
    this.availabilityMap = windowData.availabilityMap;
    this.selectedId = windowData.initialSelectedId;
    this.currency = windowData.currency;
    this.country = windowData.country;
    this.lineItemProperties = windowData.initialLineItemProperties;
    this.parentPage = parentPage;
    this.quantity = 1;

    this.storeId = windowData.storeId;
    this.productId = windowData.productId;
    this.listeners = [];

    this.parentPage.listen([['UPDATE', (data) => this._update(data)]]);
  }

  current() {
    const row = this.availabilityMap[this.selectedId];

    const lineItemRequest = new LineItemRequest(
      row.skuId,
      row.externalId,
      row.presaleId,
      row.releaseId,
      this.lineItemProperties,
      this.currency,
      this.country,
      this.quantity
    );
    return lineItemRequest;
  }

  currentShipDates() {
    return this.availabilityMap[this.selectedId].shipDates;
  }

  getState() {
    const row = this.availabilityMap[this.selectedId];
    return {
      skuId: row.skuId,
      sku: row.sku,
      presaleId: row.presaleId,
      releaseId: row.releaseId,
      isSoldOut: !row.isAvailable,
      checkoutEnabled: row.skuId && row.isAvailable,
      label: row.label,
      lineItemProperties: this.lineItemProperties,
      quantity: this.quantity,
    };
  }

  attachListener(listener) {
    this.listeners.push(listener);
  }

  _update(data) {
    if (!this.availabilityMap) {
      return;
    }

    if (data.skuExternalId) {
      const [id] = Object.entries(this.availabilityMap).find(
        ([, value]) => value?.externalId === data.skuExternalId
      );
      this.selectedId = id;
    } else if (data.sku) {
      const [id] = Object.entries(this.availabilityMap).find(
        ([, value]) => value?.sku === data.sku
      );
      this.selectedId = id;
    } else {
      this.selectedId = 'NONE';
    }

    if (data.lineItemProperties) {
      this.lineItemProperties = data.lineItemProperties;
    }

    if (data.quantity != null) {
      this.quantity = data.quantity;
    }

    for (const listener of this.listeners) {
      listener.onNewVariant();
    }
  }
}

export default SelectedVariant;
